import { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from "./auth/ProtectedRoute.jsx";

const Home = lazy(() => import("./components/Home.jsx"));
const Menu = lazy(() => import("./components/Menu.jsx"));
const Contact = lazy(() => import("./components/Contact.jsx"));
const Gallery = lazy(() => import("./components/Gallery.jsx"));
const Reservation = lazy(() => import("./components/Reservation.jsx"));
const About = lazy(() => import("./components/About.jsx"));
const Blog = lazy(() => import("./components/Blog.jsx"));
const BlogDetail = lazy(() => import("./components/BlogDetail.jsx"));
const Login = lazy(() => import("./components/Login.jsx"));
const ForgotPassword = lazy(() => import("./components/ForgotPassword.jsx"));
const ResetPassword = lazy(() => import("./components/ResetPassword.jsx"));
const SidebarMenu = lazy(() => import("./components/admin/SidebarMenu.jsx.jsx"));

function App() {
  return (
    <Router>
      <RoutesWithFooter />
    </Router>
  );
}

function RoutesWithFooter() {
  return (
    <>
      <ToastContainer />
      <Suspense fallback={<div className="route-loader">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <SidebarMenu />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
